const prepareHeadings = (headings: string | string[]) => {
  if (typeof headings === 'string') {
    headings = headings.split(',')
  }
  return headings.map(h => h.toLowerCase().trim())
}

export const validateHeadings = (
  headings: string | string[],
  headingsExample: string | string[],
  legacyHeaders?: string[],
) => {
  const preparedHeadings = prepareHeadings(headings)
  const preparedExample = prepareHeadings(headingsExample)

  const matchesFormat = preparedHeadings.every(heading => preparedExample.includes(heading))

  // Check if headers match any of the legacy formats (if provided)
  let matchesLegacyFormat = false
  if (legacyHeaders) {
    matchesLegacyFormat = legacyHeaders.some(legacyFormat => {
      const legacyHeadersArray = legacyFormat.split(',')
      const normalizedLegacy = prepareHeadings(legacyHeadersArray)
      return preparedHeadings.every(heading => normalizedLegacy.includes(heading))
    })
  }

  return matchesFormat || matchesLegacyFormat
}
